export const GRID_COLUMNS = 32;
export const GRID_ROWS = 32;
export const GRID_SIZE = 32;
export const SNAKE_LENGTH = 3;



//////////////////
// WEBPACK FOOTER
// ./src/constants/settings.js
// module id = 412
// module chunks = 0